import { Link } from "react-router-dom";
import { Home, ShoppingBag } from "lucide-react";
import { Button } from "../components/ui/button";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 — Page not found"
        description="The page you're looking for doesn't exist. Head back to the home page or browse our shrimp."
        noindex={true}
      />
      <main
        data-testid="not-found-page"
        className="min-h-[65vh] flex items-center justify-center px-6 py-16 bg-shrimp-beige/40"
      >
        <div className="max-w-xl w-full text-center space-y-8">
          <div className="space-y-2">
            <p className="text-shrimp-orange font-mono tracking-widest text-sm uppercase">
              Error 404
            </p>
            <h1 className="text-6xl sm:text-7xl font-bold text-shrimp-dark">
              Page not found
            </h1>
          </div>

          <p className="text-base text-shrimp-text leading-relaxed">
            Looks like this page swam off. The link might be broken or the page
            may have moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
            <Button asChild className="bg-shrimp-green hover:bg-shrimp-green/90" data-testid="not-found-home-btn">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Back to home
              </Link>
            </Button>
            <Button asChild variant="outline" data-testid="not-found-shop-btn">
              <Link to="/shrimp-room">
                <ShoppingBag className="w-4 h-4 mr-2" />
                Browse the shrimp room
              </Link>
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}
